// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';
import type { Icon } from 'iconsax-react';

const PolicyIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;
  const paint = color || 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask
          id={maskId}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M23.5 0.5V23.5H0.5V0.5H23.5Z" fill="white" stroke="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path
            d="M9 1.75H14C14.1339 1.75 14.25 1.86614 14.25 2C14.25 2.13386 14.1339 2.25 14 2.25H9C6.65972 2.25 4.92459 2.66134 3.79297 3.79297C2.66134 4.92459 2.25 6.65972 2.25 9V15C2.25 17.3403 2.66134 19.0754 3.79297 20.207C4.92459 21.3387 6.65972 21.75 9 21.75H15C17.3403 21.75 19.0754 21.3387 20.207 20.207C21.3387 19.0754 21.75 17.3403 21.75 15V10C21.75 9.86614 21.8661 9.75 22 9.75C22.1339 9.75 22.25 9.86614 22.25 10V15C22.25 17.6576 21.6802 19.435 20.5576 20.5576C19.435 21.6802 17.6576 22.25 15 22.25H9C6.3424 22.25 4.565 21.6802 3.44238 20.5576C2.31976 19.435 1.75 17.6576 1.75 15V9C1.75 6.3424 2.31976 4.565 3.44238 3.44238C4.565 2.31976 6.3424 1.75 9 1.75Z"
            fill={paint}
            stroke={paint}
          />
          <path
            d="M13.9072 1.77051C13.9884 1.73577 14.0974 1.74898 14.1846 1.83203L22.1768 9.82422C22.2461 9.89375 22.2676 10.007 22.2305 10.0938C22.1876 10.1935 22.0959 10.251 22 10.251H18C16.3361 10.251 15.3152 9.92345 14.6963 9.30469C14.0774 8.68577 13.75 7.6641 13.75 6V2C13.7502 1.89358 13.8152 1.80582 13.8926 1.77539L13.9004 1.77344L13.9072 1.77051ZM14.25 6C14.25 7.29018 14.4061 8.29851 15.0537 8.94629C15.7015 9.59406 16.7097 9.75 18 9.75H21.3975L20.5439 8.89648L15.1035 3.45703L14.25 2.60352V6Z"
            fill={paint}
            stroke={paint}
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { PolicyIcon };
